import {hiringFormSubmission} from '../segment'
;(function module() {
  angular.module('app.ui.form.ctrls').controller('HiringController', [
    '$log',
    '$scope',
    'logger',
    'HiringApi',
    function controller($log, $scope, logger, HiringApi) {
      let vm = this
      vm.hiring = {
        aboutUs: 'How did you hear about us?',
        jobType: 'Job/project type',
      }
      vm.notify = (type, message) => {
        switch (type) {
          case 'info':
            logger.log(message)
            break
          case 'success':
            logger.logSuccess(message)
            break
          case 'warning':
            logger.logWarning(message)
            break
          case 'error':
            logger.logError(message)
            break
          default:
            break
        }
      }

      const isValidForm = () => {
        if (vm.hiring.jobType === 'Job/project type') return false
        if (vm.hiring.aboutUs === 'How did you hear about us?') return false
        return true
      }

      vm.isHideForm = false
      vm.employerApply = async () => {
        if (isValidForm()) {
          try {
            const {status} = await HiringApi.createEmployerEnquiry(vm.hiring)
            if (status === 201) {
              vm.isHideForm = true
              hiringFormSubmission(
                vm.hiring.name,
                vm.hiring.email,
                vm.hiring.employerName,
                vm.hiring.jobType,
                vm.hiring.aboutUs
              )
              $scope.$apply()
            } else
              vm.notify(
                'error',
                'There has been an error in sending your email. Please try again'
              )
          } catch (error) {
            $log.error('error', error)
            vm.notify(
              'error',
              'There has been an error in sending your email. Please try again'
            )
          }
        } else {
          if (vm.hiring.jobType === 'Job/project type')
            vm.notify('warning', 'Please fill Job/project type field')
          if (vm.hiring.aboutUs === 'How did you hear about us?')
            vm.notify('warning', 'Please fill How did you hear about us? field')
        }
      }
    },
  ])
})()



// WEBPACK FOOTER //
// ./scripts/hiring/hiring.ctrl.js